import { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';
import type { StreamProvider } from '@vgtv/api-client';
import { AccessDefinitionEntity } from '../plugins/skin-vgtv2/services/svpApi';

export const getSubscriptionLabel = <T extends StreamProvider>(
  accessDefinitions: AccessDefinitionEntity[],
  access?: ProviderAccessMap[T]
) => {
  if (!access) {
    return '';
  }

  return accessDefinitions.find((def) => def.key === access)?.name || '';
};
